import { Link } from "react-router-dom";
import { ArrowUpRight, Code2, Gauge, SearchCheck, ShoppingBag } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { NAVSERVICES } from "@/data/navservices";

const WEBDEV = (NAVSERVICES || []).filter((s) => s.group === "webdev");

const POINTS = [
  { icon: SearchCheck, text: "SEO architecture built in from day one — URLs, schema, sitemaps and metadata are part of the build, not an afterthought." },
  { icon: Gauge, text: "Performance budgets on every build — fast Core Web Vitals are a ranking advantage we engineer, not hope for." },
  { icon: ShoppingBag, text: "E-commerce ready — Shopify, WooCommerce and custom stores structured around collections that can actually rank." },
  { icon: Code2, text: "Clean, maintainable code — WordPress for easy management, custom stacks when performance and control matter most." },
];

export function WebDevHighlight() {
  return (
    <section className="py-16 sm:py-24 lg:py-28 bg-rw-bg2 border-y border-rw-border relative overflow-hidden" data-testid="webdev-highlight-section">
      <div className="absolute -top-32 -right-32 h-80 w-80 rounded-full bg-rw-blue/8 blur-[110px]" aria-hidden="true" />
      <div className="container-rw relative grid items-center gap-12 lg:grid-cols-2">
        <Reveal>
          <p className="eyebrow mb-4 !text-rw-blue">Website Development</p>
          <h2 className="font-jakarta font-extrabold tracking-tight text-rw-text text-2xl sm:text-3xl lg:text-4xl leading-[1.12] text-balance" data-testid="webdev-highlight-title">
            We don't just rank websites.<br />
            <span className="text-rw-blue">We build them too.</span>
          </h2>
          <p className="mt-5 max-w-xl text-base sm:text-lg text-rw-muted leading-relaxed">
            Most websites fail at SEO because of how they were built. As SEO specialists who also develop,
            we build websites that are search-ready from the first commit — Shopify, WordPress, WooCommerce
            and fully custom-coded builds.
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            {WEBDEV.map((s) => (
              <Link key={s.slug} to={`/services/${s.slug}`} data-testid={`webdev-highlight-${s.slug}`}
                className="rounded-full border border-rw-border2 px-4 py-2 text-xs font-semibold text-rw-muted transition-all hover:border-rw-blue/60 hover:text-rw-blue">
                {s.name}
              </Link>
            ))}
          </div>
          <Link to="/services" data-testid="webdev-highlight-cta"
            className="mt-7 inline-flex items-center gap-2 text-sm font-semibold text-rw-blue hover:gap-3 transition-all">
            Explore Website Development <ArrowUpRight size={15} />
          </Link>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="grid gap-4 sm:grid-cols-2">
            {POINTS.map((p, i) => (
              <div key={i} className="rounded-xl border border-rw-border bg-rw-card p-5 transition-all duration-300 hover:border-rw-blue/50"
                data-testid={`webdev-point-${i + 1}`}>
                <p.icon size={22} className="text-rw-blue" />
                <p className="mt-3 text-xs sm:text-sm leading-relaxed text-rw-muted">{p.text}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
